<template>
  <Layout>
    <div class="row">
      <div class="col-8">
        <h6 class="mt-2">Incident Details</h6>
      </div>
      <div class="col-4">
        <button class="btn btn-sm btn-outline-info" disabled>
          Status: {{ selectedIncident.status }}
        </button>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Incident Id</th>
                    <td>{{ selectedIncident.id }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Vehicle Number</th>
                    <td>{{ selectedIncident.vehicle_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Incident Category</th>
                    <td>{{ selectedIncident.category_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sub Category</th>
                    <td>{{ selectedIncident.sub_category_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Source</th>
                    <td>{{ selectedIncident.source_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Description</th>
                    <td>{{ selectedIncident.description }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Chainage Number</th>
                    <td>{{ selectedIncident.ch_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Side</th>
                    <td>{{ selectedIncident.side_name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Incident Date/Time</th>
                    <td>
                      {{
                        getReadableDateTime(selectedIncident.incident_datetime)
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Reported Date/Time</th>
                    <td>
                      {{
                        new Date(
                          selectedIncident.reported_datetime
                        ).toLocaleString()
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Informed To</th>
                    <td>{{ selectedIncident.reported_to_name }}</td>
                  </tr>

                  <tr v-show="selectedIncident.category_name === 'Accident'">
                    <th scope="row">Driver Name</th>
                    <td>{{ selectedIncident.driver_name }}</td>
                  </tr>
                  <tr v-show="selectedIncident.category_name === 'Accident'">
                    <th scope="row">No. of Injured People</th>
                    <td>{{ selectedIncident.injured_count }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Response Date/Time</th>
                    <td>{{ selectedIncident.response_datetime }}</td>
                  </tr>
                  <tr>
                    <th scope="row">RPO Comment</th>
                    <td>{{ selectedIncident.comment }}</td>
                  </tr>
                  <tr v-show="selectedIncident.status !== 'Open'">
                    <th scope="row">Close Date/Time</th>
                    <td>{{ selectedIncident.close_datetime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Incident Photos</h4>
            <img
              v-for="(src, index) in incidentImages"
              :key="index"
              class="float-left image"
              @click="() => showCaptiomImg(index)"
              :src="src"
            />
          </div>
          <vue-easy-lightbox
            :visible="visibleCaption"
            :imgs="incidentImages"
            :index="index"
            @hide="handleCaptionHide"
          ></vue-easy-lightbox>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  props: {
    incidentId: String,
  },
  components: {
    VueEasyLightbox,
    Layout,
  },
  mounted() {
    this.sockets.subscribe("GET_INCIDENT_BY_ID", (data) => {
      this.selectedIncident = data[0];
    });

    this.$socket.emit(
      "REQUEST:GET_INCIDENT_BY_ID",
      JSON.stringify({ incidentId: this.incidentId })
    );
  },
  incidentImages() {
    return this.selectedIncident.images
      ? this.selectedIncident.images.map((e) => e.media_url)
      : [];
  },
  data() {
    return {
      selectedIncident: {},
      visibleCaption: false,
    };
  },
  methods: {
    handleCaptionHide() {
      this.visibleCaption = false;
    },
    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },
    getReadableDateTime(dateTime) {
      if (dateTime) {
        const date = String(dateTime).split("T");
        return `${date[0].toUpperCase()}, ${date[1].toUpperCase()}`;
      }
    },
  },
};
</script>